export const getSubRowPudding = (depth: number) => {
  if (depth === 1) return '32px'
  if (depth === 2) return '80px'
  return 0
}
